<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg2 md4 sm6 xs12>
          <v-select
            v-model="reportType"
            :items="reportTypeOptions"
            label="Loại báo cáo"
            item-text="text"
            item-value="value"
            outlined
            dense
            @change="onReportTypeChange"
          ></v-select>
        </v-flex>
        <v-flex lg2 md4 sm6 xs12>
          <v-menu
            v-model="menuStart"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="computedStartDateFormatted"
                label="Từ ngày"
                hint="DD-MM-YYYY"
                persistent-hint
                prepend-icon="event"
                outlined
                dense
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex lg2 md4 sm6 xs12>
          <v-menu
            v-model="menuEnd"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="computedEndDateFormatted"
                label="Đến ngày"
                hint="DD-MM-YYYY"
                persistent-hint
                prepend-icon="event"
                outlined
                dense
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex lg3 md4 sm6 xs12 v-if="reportType === 'licensePlate'">
          <v-autocomplete
            v-model="licensePlate"
            :items="plateOptions"
            :label="$t('table_headers.license_plate')"
            item-text="text"
            item-value="value"
            outlined
            dense
            clearable
          ></v-autocomplete>
        </v-flex>
        <v-flex lg2 md4 sm6 xs12 class="d-flex align-end" pb-5>
          <v-btn color="#a41c21" outlined @click="filter_data">Xem</v-btn>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card class="pa-4 mb-5">
            <div v-if="chartData.length">
              <highcharts :options="chartOptions"></highcharts>
            </div>
            <div v-else class="text-center py-6 grey--text text--darken-1">
              Không có dữ liệu để hiển thị
            </div>
          </v-card>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="tableItems"
              hide-default-footer
              :loading="loading"
              :mobile-breakpoint="100"
            >
              <template v-slot:item="{ item }">
                <tr v-if="reportType === 'licensePlate'">
                  <td>{{ item.LicensePlate }}</td>
                  <td>{{ item.OrderDate | display_date }}</td>
                  <td>{{ item.StoreDate | display_date }}</td>
                  <td class="text-right">{{ item.NumberOfProduct | currency }}</td>
                  <td class="text-right">{{ item.NumberOfPack | currency }}</td>
                  <td class="text-right">{{ item.Weight | currency('', 1) }}</td>
                  <td class="text-right">{{ item.Volume | currency('', 2) }}</td>
                </tr>
                <tr v-else>
                  <td>{{ item.StatusName }}</td>
                  <td class="text-right">{{ item.TruckCount | currency }}</td>
                  <td class="text-right">{{ item.NumberOfProduct | currency }}</td>
                  <td class="text-right">{{ item.NumberOfPack | currency }}</td>
                  <td class="text-right">{{ item.Weight | currency('', 1) }}</td>
                  <td class="text-right">{{ item.Volume | currency('', 2) }}</td>
                </tr>
              </template>
              <template v-slot:body.append>
                <tr class="font-weight-bold">
                  <td v-if="reportType === 'licensePlate'">{{ $t('table_headers.total_truck') }}</td>
                  <td v-else>Tổng cộng</td>
                  <td class="text-right">{{ summary.totalTruck | currency }}</td>
                  <td class="text-right" v-if="reportType === 'licensePlate'"></td>
                  <td class="text-right">{{ summary.totalOrder | currency }}</td>
                  <td class="text-right">{{ summary.totalPack | currency }}</td>
                  <td class="text-right">{{ summary.totalWeight | currency('', 1) }}</td>
                  <td class="text-right">{{ summary.totalVolume | currency('', 2) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import configs from "@/configs";

export default {
  name: "bao-cao-xe-hang",
  data() {
    return {
      reportType: 'licensePlate',
      reportTypeOptions: [
        { text: 'Báo cáo theo biển số xe', value: 'licensePlate' },
        { text: 'Báo cáo theo trạng thái xe', value: 'status' }
      ],
      dateRange: {
        startDate: moment.utc(Date.now()).startOf("month").toISOString().substr(0, 10),
        endDate: moment.utc(Date.now()).endOf("month").toISOString().substr(0, 10)
      },
      menuStart: false,
      menuEnd: false,
      licensePlate: null
    };
  },
  computed: {
    ...mapState({
      truckReport: state => state.report.truckReport,
      loading: state => state.report.loading
    }),
    tableItems() {
      return this.truckReport.items || [];
    },
    chartData() {
      return this.truckReport.chart || [];
    },
    summary() {
      return this.truckReport.summary || {
        totalTruck: 0,
        totalOrder: 0,
        totalPack: 0,
        totalWeight: 0,
        totalVolume: 0,
        totalRevenue: 0
      };
    },
    plateOptions() {
      const plates = this.truckReport.plates || [];
      return plates.map(item => ({ text: item, value: item }));
    },
    headers() {
      if (this.reportType === 'status') {
        return [
          { text: 'Trạng thái', value: 'StatusName', filterable: false },
          { text: 'Số xe', value: 'TruckCount', align: 'end', filterable: false },
          { text: this.$t('table_headers.order_count'), value: 'NumberOfProduct', align: 'end', filterable: false },
          { text: this.$t('table_headers.number_of_pack'), value: 'NumberOfPack', align: 'end', filterable: false },
          { text: this.$t('table_headers.weight'), value: 'Weight', align: 'end', filterable: false },
          { text: this.$t('table_headers.volume'), value: 'Volume', align: 'end', filterable: false }
        ];
      }
      return [
        { text: this.$t('table_headers.license_plate'), value: 'LicensePlate', filterable: false },
        { text: this.$t('table_headers.truck_date'), value: 'OrderDate', filterable: false },
        { text: this.$t('table_headers.warehouse_date'), value: 'StoreDate', filterable: false },
        { text: this.$t('table_headers.order_count'), value: 'NumberOfProduct', align: 'end', filterable: false },
        { text: this.$t('table_headers.number_of_pack'), value: 'NumberOfPack', align: 'end', filterable: false },
        { text: this.$t('table_headers.weight'), value: 'Weight', align: 'end', filterable: false },
        { text: this.$t('table_headers.volume'), value: 'Volume', align: 'end', filterable: false }
      ];
    },
    chartOptions() {
      if (this.reportType === 'status') {
        var categories = this.chartData.map(function(item) { return item.StatusName; });
        return {
          chart: { type: 'column' },
          title: { text: 'Thống kê xe theo trạng thái' },
          credits: { enabled: false },
          xAxis: { categories: categories },
          yAxis: [
            { title: { text: 'Khối lượng (kg/m3)' } },
            { title: { text: 'Số xe' }, opposite: true }
          ],
          tooltip: { shared: true },
          legend: { align: 'center' },
          series: [
            {
              type: 'column',
              name: 'Tổng cân (kg)',
              data: this.chartData.map(function(item) { return Number(item.TotalWeight) || 0; })
            },
            {
              type: 'column',
              name: 'Tổng khối (m3)',
              data: this.chartData.map(function(item) { return Number(item.TotalVolume) || 0; })
            },
            {
              type: 'spline',
              name: 'Số xe',
              yAxis: 1,
              data: this.chartData.map(function(item) { return Number(item.TruckCount) || 0; })
            }
          ]
        };
      }
      var categories = this.chartData.map(function(item) {
        const date = moment(item.ReportDate);
        return date.isValid() ? date.format(configs.SHORT_DATE_FORMAT) : item.ReportDate;
      });
      return {
        chart: { zoomType: 'xy' },
        title: { text: 'Hiệu suất xe hàng' },
        credits: { enabled: false },
        xAxis: [{ categories }],
        yAxis: [{
          title: { text: 'Khối lượng (kg/m3)' }
        }, {
          title: { text: 'Số xe' },
          opposite: true
        }],
        tooltip: { shared: true },
        legend: { align: 'center' },
        series: [
          {
            type: 'column',
            name: 'Tổng cân (kg)',
            data: this.chartData.map(item => Number(item.TotalWeight) || 0)
          },
          {
            type: 'column',
            name: 'Tổng khối (m3)',
            data: this.chartData.map(item => Number(item.TotalVolume) || 0)
          },
          {
            type: 'spline',
            name: 'Số xe',
            yAxis: 1,
            data: this.chartData.map(item => Number(item.TotalTruck) || 0)
          }
        ]
      };
    },
    computedStartDateFormatted () {
      return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
    },
    computedEndDateFormatted () {
      return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
    }
  },
  methods: {
    onReportTypeChange() {
      this.filter_data();
    },
    filter_data() {
      var params = {
        startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
        endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
        reportType: this.reportType
      };
      if (this.reportType === 'licensePlate' && this.licensePlate) {
        params.licensePlate = this.licensePlate;
      }
      this.$store.dispatch('report/getTruckReport', params);
    }
  },
  mounted() {
    this.filter_data();
    this.$root.$emit('REQUEST_ROOT_OPTION', {});
    this.$root.$on('REQUEST_REFRESH_DATA', this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off('REQUEST_REFRESH_DATA', this.filter_data);
  }
};
</script>
